import { render, staticRenderFns } from "./MagazineForm.vue?vue&type=template&id=cdd7bbd6&scoped=true&"
import script from "./MagazineForm.vue?vue&type=script&lang=js&"
export * from "./MagazineForm.vue?vue&type=script&lang=js&"
import style0 from "./MagazineForm.vue?vue&type=style&index=0&id=cdd7bbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd7bbd6",
  null
  
)

export default component.exports